import React, { useEffect, useState } from 'react'
import * as API from "../../framework/API/api"
import { DATETIMEFORMATS, ENTITYNAME, EPG_IMPORT_FIELD_TYPE, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ReplacementOptionEditForm from './ReplacementOptionEditForm';
import ToastNotification from '../../components/ToastNotification';

const ChannelEPGMappingConfigEditForm = (props) => {
    console.log(props?.item)
    const lang = useTranslation();

    const blankDataItem = {
        ...props?.item,
        ImportField: props?.item?.copy ? "Copy of " + props?.item?.ImportField : props?.item?.ImportField ?? "",
        Archive: props?.item?.Archive ?? false,
        Channel: props?.item?.Channel ?? {},
        FormField: props?.item?.FormField ?? {},
        EpgImportFieldType: props?.item?.EpgImportFieldType ? { _id: props?.item?.EpgImportFieldType, Description: utility.getKeyByValue(EPG_IMPORT_FIELD_TYPE, props?.item?.EpgImportFieldType) } : {},
        FixedValue: props?.item?.FixedValue ?? "",
        DateTimeFormat: props?.item?.DateTimeFormat ? DATETIMEFORMATS.find(x => x.Type === props.item.DateTimeFormat) : "",
        DefaultValue: props?.item?.DefaultValue ?? "",
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channels, setChannels] = useState([]);
    const [formFields, setFormFields] = useState([]);
    const [fileTypes, setFileTypes] = useState([]);
    const [replacementData, setReplacementData] = useState(props?.item?.ReplaceOptions ?? []);

    useEffect(() => {
        loadCombo()
    }, [])

    const loadCombo = async () => {
        const fileTypeRes = Object.keys(EPG_IMPORT_FIELD_TYPE).map(x => ({
            _id: EPG_IMPORT_FIELD_TYPE[x],
            Description: x
        }));
        setFileTypes(fileTypeRes);
        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannels(channelRes.data);
        const formFieldRes = await API.getData(ENTITYNAME.FormFields, { query: ['entityName', '=', ENTITYNAME.PlaylistEpgImport] });
        setFormFields(formFieldRes.data);
    }

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (!dataItem.Channel || Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        return true;

    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem._id,
            SID: dataItem.SID,
            ImportField: dataItem?.ImportField,
            Channel: dataItem?.Channel && Object.keys(dataItem?.Channel).length > 0 ? {
                _id: dataItem?.Channel?._id,
                ShortChannelName: dataItem?.Channel?.ShortChannelName,
                FullChannelName: dataItem?.Channel?.FullChannelName
            } : {},
            FormField: dataItem?.FormField && Object.keys(dataItem?.FormField).length > 0 ? {
                _id: dataItem?.FormField?._id,
                entityName: dataItem?.FormField?.entityName,
                name: dataItem?.FormField?.name,
                label: dataItem?.FormField?.label,
                type: dataItem?.FormField?.type
            } : {},
            EpgImportFieldType: dataItem?.EpgImportFieldType?._id,
            DateTimeFormat: dataItem?.DateTimeFormat?.Type ?? "",
            FixedValue: dataItem?.FixedValue,
            ReplaceOptions: replacementData,
            DefaultValue: dataItem?.DefaultValue,
            Archive: dataItem.Archive ?? false
        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.ChannelEPGMappingConfig, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CHANNEL_EPG_MAPPING_CONFIG, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.ChannelEPGMappingConfig);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onReplaceSubmit = (dataList) => {
        setReplacementData(dataList)
    }

    return (
        <>
            <BossDialog
                title={props.item.ImportField ?? lang.channel_epg_mapping_config_dialog_header}
                onClose={props.cancelEdit}
                width={"600px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                <div className='row mt-2'>
                    <div className='col-6'>
                        <label>{lang.channel_label} *</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            className="form-control form-control-sm"
                            data={channels}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            onChange={onChange}
                            value={dataItem.Channel}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.form_field_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            className="form-control form-control-sm"
                            data={formFields}
                            name="FormField"
                            textField="label"
                            dataItemKey="_id"
                            onChange={onChange}
                            value={dataItem.FormField}
                        />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className="col-6">
                        <label htmlFor="">{lang.import_field_label} </label>
                        <input
                            className="form-control form-control-sm"
                            type="text"
                            name="ImportField"
                            value={dataItem.ImportField}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.epg_import_field_type_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            className="form-control form-control-sm"
                            data={fileTypes}
                            name="EpgImportFieldType"
                            textField="Description"
                            dataItemKey="_id"
                            onChange={onChange}
                            value={dataItem.EpgImportFieldType}
                        />
                    </div>
                </div>
                <div className='row mt-2'>
                    {dataItem?.EpgImportFieldType?._id == EPG_IMPORT_FIELD_TYPE.FIXED &&
                        <div className='col-6'>
                            <label htmlFor="">{lang.fixed_value_label} </label>
                            <input
                                className="form-control form-control-sm"
                                type="text"
                                name="FixedValue"
                                value={dataItem.FixedValue}
                                onChange={onChange}
                            />
                        </div>
                    }
                    {dataItem?.EpgImportFieldType?._id == EPG_IMPORT_FIELD_TYPE.DEFAULT &&
                        <div className='col-6'>
                            <label htmlFor="">{lang.default_value_label} </label>
                            <input
                                className="form-control form-control-sm"
                                type="text"
                                name="DefaultValue"
                                value={dataItem.DefaultValue}
                                onChange={onChange}
                            />
                        </div>
                    }
                    {(dataItem?.EpgImportFieldType?._id == EPG_IMPORT_FIELD_TYPE.DATE_MS || dataItem?.EpgImportFieldType?._id == EPG_IMPORT_FIELD_TYPE.TIME_MS) &&
                        <div className='col-6'>
                            <label htmlFor="">{lang.format_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={DATETIMEFORMATS}
                                name="DateTimeFormat"
                                textField="Type"
                                dataItemKey="ID"
                                value={dataItem.DateTimeFormat}
                                onChange={onChange}
                            />
                        </div>
                    }
                    <div className='col-6'>
                        <input
                            style={{ border: "1px solid grey", marginTop: "26px" }}
                            name={"Archive"}
                            type='checkbox'
                            onChange={onChange}
                        />
                        <label className="ml-2">{lang.archive}</label>
                    </div>
                </div>
                {dataItem?.EpgImportFieldType?._id == EPG_IMPORT_FIELD_TYPE.REPLACE &&
                    <div className='row mt-2'>
                        <div className="col-12">
                            <ReplacementOptionEditForm onReplaceSubmit={onReplaceSubmit} data={replacementData} setData={setReplacementData} />
                        </div>
                    </div>
                }
            </BossDialog >
        </>
    )
}

export default ChannelEPGMappingConfigEditForm
